// components/DescriptionTooltip/DescriptionTooltip.jsx
import React from "react";
import "./DescriptionTooltip.css";

export const DescriptionTooltip = ({ text = "", maxLength = 20 }) => {
  const truncated =
    text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

  const handleMouseEnter = (e) => {
    const tooltip = e.currentTarget.querySelector(".description-hover-box");
    if (!tooltip) return;

    const rect = tooltip.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    if (spaceBelow < 120 && spaceAbove > 150) {
      tooltip.classList.add("flip-up");
    } else {
      tooltip.classList.remove("flip-up");
    }
  };

  const handleMouseLeave = (e) => {
    const tooltip = e.currentTarget.querySelector(".description-hover-box");
    if (tooltip) tooltip.classList.remove("flip-up");
  };

  return (
    <span
      className="description-ellipsis-wrapper"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span className="description-ellipsis">{truncated}</span>
      <div className="description-hover-box">{text}</div>
    </span>
  );
};


